import { h2ClassName, inputClassName } from '@/components/ui/styles';
import useProxyPoolCreationForm from '@/store/proxyPoolCreationFormStore';

export default function NameSelect() {
  const { name, setName } = useProxyPoolCreationForm();

  return (
    <div className="mb-4">
      <h2 className={h2ClassName}>Pool name</h2>
      <div className="mt-2">
        <input
          className={inputClassName + 'bg-white'}
          id="proxyPoolName"
          minLength={1}
          maxLength={40}
          value={name}
          placeholder="Default proxy pool"
          onChange={(e) => {
            setName(e.target.value);
          }}
        />
      </div>
    </div>
  );
}
